/*
 * Purchase option on a cart line: switch a line between one-time and a subscription
 * schedule without leaving the drawer.
 *
 * A file rather than an inline script, and listening on `document` rather than on the
 * controls, for the same reason as cart-upgrades.js: the drawer rewrites its own markup
 * with innerHTML, which never runs inserted scripts and replaces anything bound
 * directly.
 *
 * Remove then add, rather than `change.js` with a selling_plan. The cart merges lines
 * that match on variant and plan, and changing a line in place can leave the customer
 * holding two of something they asked to have one of.
 */
(function () {
  var root = function () {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  };

  function swap(control, sellingPlan) {
    var lineKey = control.dataset.lineKey;
    var variantId = Number(control.dataset.variantId);
    var quantity = Number(control.dataset.lineQuantity) || 1;
    if (!lineKey || !variantId) return;

    var item = { id: variantId, quantity: quantity };
    if (sellingPlan) item.selling_plan = Number(sellingPlan);

    control.disabled = true;
    control.dataset.busy = "true";

    fetch(root() + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error("change failed");
        return fetch(root() + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [item] }),
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error("add failed");

        // Inside the upsell app's drawer, ask it to redraw rather than reloading the
        // page under the customer. Its own integrations use this event for exactly this.
        if (document.querySelector(".ocu-cart-drawer")) {
          try {
            window.dispatchEvent(
              new CustomEvent("ocu:cart:update", { detail: { preventEvent: true } })
            );
            // Replacing the line the app was drawing can leave the drawer shut behind
            // the customer. Asking it to open again is harmless when it already is.
            window.dispatchEvent(new CustomEvent("ocu:cart:open"));
            return;
          } catch (error) {
            /* fall through to the reload */
          }
        }

        window.location.reload();
      })
      .catch(function () {
        // Reload either way. The cart is the source of truth and the customer needs to
        // see what actually happened rather than a stale line.
        window.location.reload();
      });
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest(".wn-plan__upgrade");
    if (!button || button.disabled) return;
    swap(button, button.dataset.sellingPlan);
  });

  document.addEventListener("change", function (event) {
    var select = event.target.closest(".wn-plan__select");
    if (!select || select.disabled) return;
    swap(select, select.value);
  });
})();
